import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex justify-between bg-gray-900 p-2" };
const _hoisted_2 = { href: "/" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "flex flex-col justify-center gap-1 text-white",
    "data-testid": "usd-clp-reference"
};
const _hoisted_5 = { class: "h-max rounded-md bg-gray-700 p-2" };
const _hoisted_6 = {
    key: 0,
    class: "text-sm text-gray-300"
};
const _hoisted_7 = {
    key: 1,
    class: "text-sm text-yellow-400"
};
const _hoisted_8 = {
    key: 1,
    class: "h-max rounded-md bg-gray-700 p-2"
};
const _hoisted_9 = { class: "flex flex-col justify-between" };
const _hoisted_10 = {
    class: "inline-flex h-max justify-center space-x-2 rounded-md bg-blue-700 px-6 py-2 text-white",
    href: "/users/edit"
};
import { csrfToken } from 'utils/csrf';
import { formatMoney } from 'utils/format-money';
export default /*@__PURE__*/ _defineComponent({
    __name: 'the-navbar',
    props: {
        usdClpReference: { default: undefined }
    },
    setup(__props) {
        function signOut() {
            fetch('/users/sign_out', {
                method: 'DELETE',
                headers: {
                    'X-CSRF-Token': csrfToken(),
                },
            }).then(() => window.location.replace('/users/sign_in')).catch();
        }
        const props = __props;
        function formatRate(reference) {
            return formatMoney(Number(reference.usd_clp), 'CLP', { maximumFractionDigits: 2 });
        }
        function formatTime(time) {
            return new Date(time).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' });
        }
        return (_ctx, _cache) => {
            const _component_base_button = _resolveComponent("base-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", _hoisted_2, [
                    _createElementVNode("img", {
                        class: "h-24 self-center",
                        alt: "logo",
                        src: require('assets/images/logo.svg')
                    }, null, 8, _hoisted_3)
                ]),
                (props.usdClpReference !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (props.usdClpReference)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`navbar.usdClp.${props.usdClpReference.source}`, { rate: formatRate(props.usdClpReference) })), 1),
                                (props.usdClpReference.source === 'manual')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('navbar.usdClp.updatedAt', { time: formatTime(props.usdClpReference.as_of) })), 1))
                                    : _createCommentVNode("", true),
                                (props.usdClpReference.outdated)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('navbar.usdClp.outdated')), 1))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('navbar.usdClp.unavailable')), 1))
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_base_button, {
                        type: "button",
                        theme: "secondary",
                        class: "justify-center",
                        label: "users.actions.logout",
                        onClick: signOut
                    }),
                    _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('users.actions.updateProfile')), 1)
                ])
            ]));
        };
    }
});
